import { useDevicesStore } from '../stores/devicesStore'

let markersMap = new Map()
let updateIntervalId = null



const createGatewayIcon = () => {
    const google = window.google
    return {
        url: '/dock.svg',
        scaledSize: new google.maps.Size(40, 40),
        anchor: new google.maps.Point(20, 20)
    }
}

const createDroneIcon = () => {
    const google = window.google
    return {
        path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
        fillColor: '#059669',
        fillOpacity: 1,
        strokeColor: '#064E3B',
        strokeWeight: 2,
        scale: 6,
        rotation: 0
    }
}

const getDeviceType = (device) => {
    
    if (device.domain === 3) return 'gateway'
    if (device.domain === 0) return 'drone'
    return 'unknown'
}

const isValidCoordinate = (lat, lng) => {
    return lat !== 0 && lng !== 0 && 
           lat !== null && lng !== null && 
           lat !== undefined && lng !== undefined &&
           !isNaN(lat) && !isNaN(lng) &&
           lat >= -90 && lat <= 90 &&
           lng >= -180 && lng <= 180
}


const updateDeviceMarker = (device, devicesStore, map) => {
    const google = window.google
    const deviceId = device.device_sn
    const isOnline = devicesStore.getDeviceConnected(deviceId)
    const telemetry = devicesStore.getDeviceTelemetry(deviceId)
    
    const lat = telemetry.latitude 
    const lng = telemetry.longitude
    
    const existingMarker = markersMap.get(deviceId)
    
    if (!isOnline || !isValidCoordinate(lat, lng)) {
        if (existingMarker) {
            existingMarker.setMap(null)
            markersMap.delete(deviceId)
        }
        return
    }
    
    const deviceType = getDeviceType(device)
    const icon = deviceType === 'gateway' ? createGatewayIcon() : createDroneIcon()
    
    if (existingMarker) {
        existingMarker.setPosition({ lat: parseFloat(lat), lng: parseFloat(lng) })
        existingMarker.setIcon(icon)
    } else {
        const marker = new google.maps.Marker({
            position: { lat: parseFloat(lat), lng: parseFloat(lng) },
            map: map,
            title: `${device.device_name} (${deviceId})`,
            icon: icon
        })
        markersMap.set(deviceId, marker)
        
        // Center map on new marker with zoom 18
        map.setCenter({ lat: parseFloat(lat), lng: parseFloat(lng) })
        map.setZoom(20)
    }
}


const updateAllMarkers = (devicesStore, map) => {
    const allDevices = devicesStore.getDevices()
    
    allDevices.forEach(device => {
        updateDeviceMarker(device, devicesStore, map)
        
        if (device.children) {
            updateDeviceMarker(device.children, devicesStore, map)
        }
    })
    
    const activeDeviceIds = new Set()
    allDevices.forEach(device => {
        activeDeviceIds.add(device.device_sn)
        if (device.children) {
            activeDeviceIds.add(device.children.device_sn)
        }
    })
    
    markersMap.forEach((marker, deviceId) => {
        if (!activeDeviceIds.has(deviceId)) {
            marker.setMap(null)
            markersMap.delete(deviceId)
        }
    })
}

export const manageDevicesMarkers = (mapManager) => {
    const map = mapManager.getMapInstance()
    if (!map) {
        console.error('Map instance not available')
        return null
    }
    
    const devicesStore = useDevicesStore()
    
    if (updateIntervalId) {
        clearInterval(updateIntervalId)
    }
    
    const updateMarkers = () => {
        try {
            updateAllMarkers(devicesStore, map)
        } catch (error) {
            console.error('Error updating markers:', error)
        }
    }
    
    updateMarkers()
    
    updateIntervalId = setInterval(updateMarkers, 1000)
    
    return {
        intervalId: updateIntervalId,
        stop: () => {
            if (updateIntervalId) {
                clearInterval(updateIntervalId)
                updateIntervalId = null
            }
        },
        clearAllMarkers: () => {
            markersMap.forEach(marker => marker.setMap(null))
            markersMap.clear()
        },
        getMarkersCount: () => markersMap.size
    }
}